import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IAppNetworkService } from "./app-network.service.interface";
import { map, delay, switchMap } from "rxjs/operators";
import { ConnectionService, ConnectionState } from "ng-connection-service";
@Injectable({
  providedIn: "root",
})
export class AppNetworkService implements IAppNetworkService {
  private _isConnected: boolean = true;
  constructor(private _connectionService: ConnectionService) {}

  public networkStatusChanged(): Observable<boolean> {
    return this._connectionService.monitor().pipe(
      switchMap((newState: ConnectionState) => {
        
        if (newState.hasNetworkConnection) {
          return of(newState.hasNetworkConnection).pipe(delay(50000));
        } else {
          return of(newState.hasNetworkConnection);
        }
      }),
      map((hasNetworkConnection) => {
        this._isConnected = hasNetworkConnection;
        return hasNetworkConnection;
      })
    );
  }

  public isConnected(): boolean {
    return this._isConnected;
  }
}
